import { QueryObserverOptions, useQuery } from 'react-query';

import { useDlVaultContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';

import getAllUsers, { GetAllUsersInput, GetAllUsersOutput } from '.';

type TrimmedGetAllUsersInput = Omit<GetAllUsersInput, 'dlVaultContract'>;

export type UseGetAllUsersQueryKey = [
  FunctionKey.GET_ALL_USERS,
  TrimmedGetAllUsersInput,
];

type Options = QueryObserverOptions<
  GetAllUsersOutput,
  Error,
  GetAllUsersOutput,
  GetAllUsersOutput,
  UseGetAllUsersQueryKey
>;

const useGetAllUsers = (input: TrimmedGetAllUsersInput, options?: Options) => {
  const dlVaultContract = useDlVaultContract();

  return useQuery(
    [FunctionKey.GET_ALL_USERS, input],
    () => getAllUsers({ dlVaultContract, ...input }),
    options,
  );
};

export default useGetAllUsers; 